import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'Understand how underground mines are laid out, mined, supported, ventilated and operated. 6 professional volumes, 5 exclusive bonuses and instant access.';
export function App() {
  useEffect(() => {
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="min-h-screen w-full overflow-hidden bg-slate-950 font-sans text-slate-300 antialiased" data-id="element-0" data-mp="nwc582htoe10">
      <MetaPixel data-id="element-1" data-mp="stkj3qvxtvwg" />
      <main data-id="element-2" data-mp="st2k4mhw53ku">
        <Hero data-id="element-3" data-mp="swqaxdvybbvv" />
        <LookInsideCarousel data-id="element-4" data-mp="36hwf6uoms18" />
        <ProblemSection data-id="element-5" data-mp="35ozexlizgwa" />
        <SystemSection data-id="element-6" data-mp="356wxj89s6fx" />
        <ModulesSection data-id="element-7" data-mp="38kv0f9whthk" />
        <BonusSection data-id="element-8" data-mp="3ud1glcmeruc7" />
        <UrgencySection data-id="element-9" data-mp="3udkmtw2p4uae" />
        <PricingSection data-id="element-10" data-mp="3uc9j1w993mja" />
        <GuaranteeSection data-id="element-11" data-mp="3uf5ijp0qyj9u" />
        <FAQ data-id="element-12" data-mp="d57gn6a1wokn" />
        <ClosingSection data-id="element-13" data-mp="d4xpvgh6mddw" />
        <SummaryTable data-id="element-14" data-mp="d45sq17xs7li" />
        <FinalCta data-id="element-15" data-mp="d2l6qzzotwz9" />
      </main>
      <Footer data-id="element-16" data-mp="851kpdwr0fwr" />
      <PurchaseNotification data-id="element-17" data-mp="85b8qvy8gczt" />
    </div>;
}